import { Button, Modal, Text } from '@mantine/core'

interface SaveResultModalProps {
  opened: boolean
  onClose: () => void
  status: { type: 'success' | 'error'; message?: string } | null
  onConfirm: () => void
}

const SaveResultModal: React.FC<SaveResultModalProps> = ({
  opened,
  onClose,
  status,
  onConfirm,
}) => {
  const isSuccess = status?.type === 'success'

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      centered
      size="sm"
      zIndex={2000}
      overlayProps={{ zIndex: 1999 }}
      title={isSuccess ? 'Save complete.' : 'Save Failed'}
    >
      <Text size="md" mb="lg">
        {status?.message}
      </Text>

      <Button onClick={onConfirm} variant="filled">
        OK
      </Button>
    </Modal>
  )
}

export default SaveResultModal
